<template>

  <QueueDefaultWidget
    v-if="template === 'boxes'"
    :queueData="displayQueueData"
    :queueConfig="queueConfig"
    :border-radius="borderRadius"
    :numberTxt="numberTxt"
    :counterTxt="counterTxt"
    :config="config"
  />
  <QueueLeafWidget
    v-if="template === 'leaf'"
    :queueData="displayQueueData"
    :queueConfig="queueConfig"
    :border-radius="borderRadius"
    :numberTxt="numberTxt"
    :counterTxt="counterTxt"
    :config="config"
  />
  <QueueBlocksWidget
    v-if="template === 'blocks'"
    :queueData="displayQueueData"
    :queueConfig="queueConfig"
    :border-radius="borderRadius"
    :numberTxt="numberTxt"
    :counterTxt="counterTxt"
    :config="config"
  />
</template>

<script lang="ts">
export default {
  name: "QueueDefaultWidget",
};
</script>

<script setup lang="ts">
import QueueDefaultWidget from "@/components/dynamic/QueueDefaultWidget.vue";
import QueueLeafWidget from "@/components/dynamic/QueueLeafWidget.vue";
import QueueBlocksWidget from "@/components/dynamic/QueueBlocksWidget.vue";
import { ref, defineProps, computed, onMounted, nextTick } from "vue";
const props = defineProps<{
  queueData: Array<any>;
  queueConfig: any;
  borderRadius: number;
  config: any;
}>();

const template = computed(() => {
  if (!props.config.queueConfig.template) {
    return "boxes";
  }
  return props.config.queueConfig.template;
});

// queueConfig.queues or queueId, only tickets for those queue lines are shown
function getScopedQueueIds(queueConfig: any): number[] | null {
  const queues = queueConfig?.queues;
  if (Array.isArray(queues) && queues.length > 0) {
    return queues.map((id: any) => Number(id)).filter((id) => !Number.isNaN(id));
  }
  const queueId = queueConfig?.queueId;
  if (queueId !== undefined && queueId !== null && queueId !== "") {
    const id = Number(queueId);
    return Number.isNaN(id) ? null : [id];
  }
  return null;
}

function filterTicketsByQueueScope(data: any[], queueConfig: any): any[] {
  const scopeIds = getScopedQueueIds(queueConfig);
  if (!scopeIds || scopeIds.length === 0) {
    return data;
  }
  return data.filter((ticket) => {
    const lineId = Number(ticket.queue_line_id);
    return !Number.isNaN(lineId) && scopeIds.includes(lineId);
  });
}

// queue data scoped by queues, then maxRows ordered by statusUpdateTimestamp
const displayQueueData = computed(() => {
  let data = filterTicketsByQueueScope(props.queueData ?? [], props.config?.queueConfig);
  const raw = props.config?.queueConfig?.maxRows;
  const maxRows = typeof raw === "number" ? raw : Number(raw);
  if (raw == null || raw === undefined || Number.isNaN(maxRows) || maxRows === 0 || maxRows <= 0) {
    return data;
  }
  const byTimestamp = [...data].sort((a, b) => {
    const ta = a?.statusUpdateTimestamp ?? a?.date ?? 0;
    const tb = b?.statusUpdateTimestamp ?? b?.date ?? 0;
    return tb - ta; // descending: most recent first
  });
  return byTimestamp.slice(0, maxRows);
});

//set counter and number text
const numberTxt = ref("");
const counterTxt = ref("");
const setHeaderText = () => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  const displayConfig = JSON.parse(displayData.config || "{}");
  const qc = props.config?.queueConfig || {};
  const voiceCall = qc.voice_call ?? props.config?.voice_call ?? displayConfig.voice_call;

  if (voiceCall == 1) {
    counterTxt.value =
      qc.textCounter ??
      props.config?.textCounter ??
      displayConfig.textCounter ??
      "";
    numberTxt.value =
      qc.textNumber ??
      props.config?.textNumber ??
      displayConfig.textNumber ??
      "";
  } else {
    const lang = localStorage.getItem("Language");
    if (lang == "fr") {
      counterTxt.value = "Guichet";
      numberTxt.value = "Numéro";
    } else if (lang == "en") {
      counterTxt.value = "Counter";
      numberTxt.value = "Number";
    } else {
      counterTxt.value = "شباك";
      numberTxt.value = "رقم";
    }
  }
};

onMounted(() => {
  setHeaderText();
})


</script>

<style scoped>

</style>